import { render, staticRenderFns } from "./CheckTable.vue?vue&type=template&id=248e5efc&scoped=true"
import script from "./CheckTable.vue?vue&type=script&lang=js"
export * from "./CheckTable.vue?vue&type=script&lang=js"
import style0 from "./CheckTable.vue?vue&type=style&index=0&id=248e5efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e5efc",
  null
  
)

export default component.exports